import { useMutation } from '@tanstack/react-query';
import { requestAccountDeletion } from '@/lib/api/settings/api';

/**
 * Mutation hook for requesting account deletion
 */
export function useAccountDeletion() {
    return useMutation({
        mutationFn: () => requestAccountDeletion(),
    });
}
